module.exports = __webpack_public_path__ + "img/galeria-esp-marinas-3.26109641.jpg";